export type Co2eDisplayState = {
  isEnabled: boolean;
  isDisabled: boolean;
};

const CO2E_ALWAYS_VISIBLE: Co2eDisplayState = {
  isEnabled: true,
  isDisabled: false,
};

/**
 * Whether CO₂e results are shown in lists and charts. CO₂e is always visible;
 * there is no user-facing toggle.
 */
export const useCo2eVisible = (): Co2eDisplayState => CO2E_ALWAYS_VISIBLE;
